// You can find the id here
// https://portal.sourcepoint.com/consent_v2/vendor_lists/edit?id=6233296a293cdf6b366969ee&non_iab=false
// Vendor: Adobe Audience Manager, Adobe Experience Platform
const ADOBE_AUDIENCE_MANAGER_ID: string = '5ee34ea5b8e05c164f6f8ffe'; // IAB
export default (grants: TSourcePointGrants): boolean => {
  return grants[ADOBE_AUDIENCE_MANAGER_ID]?.vendorGrant;
};
